import { camelCase } from 'lodash';
export const byFieldName = (f, fieldName)=>camelCase(f.fieldName) === camelCase(fieldName);
